import React from 'react';
import { captureBug } from '../services/bugReportService';

interface Props {
    children: React.ReactNode;
}

interface State {
    hasError: boolean;
}

export class ErrorBoundary extends React.Component<Props, State> {
    // No @types/react in this repo: React resolves untyped, so the inherited
    // `props` member must be declared explicitly (type-only, no runtime emit).
    declare readonly props: Props;
    state: State = { hasError: false };

    static getDerivedStateFromError(): State {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: React.ErrorInfo) {
        try {
            captureBug({
                message: error?.message || 'Unbekannter Renderfehler',
                stack: error?.stack,
                componentStack: info?.componentStack || undefined,
                source: 'boundary'
            });
        } catch { /* reporter must never crash the boundary */ }
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen flex flex-col items-center justify-center bg-slate-50 p-6 text-center">
                    <h1 className="text-xl font-bold text-slate-800 mb-2">Ein Fehler ist aufgetreten</h1>
                    <p className="text-sm text-slate-500 mb-6 max-w-md">
                        Der Fehler wurde automatisch an die Administratoren gemeldet. Bitte laden Sie die Seite neu.
                    </p>
                    <button
                        onClick={() => window.location.reload()}
                        className="px-4 py-2 text-sm font-bold rounded-xl bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm"
                    >
                        Seite neu laden
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}
